import * as React from "react";
const SvgFiRrAuditAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M13 6a1 1 0 0 1-1 1H6a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1m-2 3H7a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m12 7.236V19c0 2.757-2.243 5-5 5H6c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h10c2.757 0 5 2.243 5 5v6.764l1.789 3.578c.138.276.211.585.211.894M6 22h9V2H6C4.346 2 3 3.346 3 5v14c0 1.654 1.346 3 3 3m15-5.764-1.789-3.578a2 2 0 0 1-.211-.894V5a3 3 0 0 0-2-2.816V22h1c1.654 0 3-1.346 3-3z"
    />
  </svg>
);
export default SvgFiRrAuditAlt;
